import { render, staticRenderFns } from "./cRecipe.vue?vue&type=template&id=27a07e56&scoped=true"
import script from "./cRecipe.vue?vue&type=script&lang=js"
export * from "./cRecipe.vue?vue&type=script&lang=js"
import style0 from "./cRecipe.vue?vue&type=style&index=0&id=27a07e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a07e56",
  null
  
)

export default component.exports